// @flow

import styled, { css } from "styled-components";
import { fontBold, fontNormal, defaultSize } from "@fdr/static-ui/Typography";
import buildColor from "@fdr/static-ui/ColorPalette";

export const LinkDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${buildColor("blue", "D1")};
  font-family: ${fontBold};
  font-weight: 700;
  font-size: ${defaultSize};
  line-height: 125%;
`;

export const Title = styled.h1`
  color: ${buildColor("grey", "D4")};
  font-family: ${fontBold};
  font-weight: 500;
  margin-bottom: 2px;
  height: 19px;
  font-size: 16px;
`;
export const UpperSection = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  width: 100%;
  align-items: flex-start;
  border-bottom: 1px solid ${buildColor("grey", "L2")};
  margin-bottom: 12px;
  padding: 10px 12px 8px 16px;
`;

export const ListContainer = styled.ul`
  width: 100%;
  display: flex;
  align-items: center;
  flex-flow: row nowrap;
  justify-content: flex-start;
  overflow-x: auto;
  padding-bottom: 12px;

  &::after {
    content: "";
    display: inline-block;
    min-width: 12px;
    height: 112px;
  }
`;

export const UpcomingContainer = styled.li`
  background: ${buildColor("white", "100")};
  border-radius: 4px;
  border: 1px solid ${buildColor("grey", "L2")};
  min-width: 142px;
  overflow: hidden;

  &:hover {
    ${({ isFeatured }) =>
      isFeatured
        ? css`
            a:nth-of-type(1) {
              background-color: ${buildColor("grey", "L4")};
            }
          `
        : css`
            a {
              background-color: ${buildColor("grey", "L4")};
            }
          `}
  }

  &:first-child {
    margin-left: 16px;
  }

  &:not(:first-child) {
    margin-left: 8px;
  }

  & > a {
    width: 100%;
    display: block;
  }

  ${({ isOpeningApp }) =>
    isOpeningApp &&
    css`
      & > div {
        pointer-events: none;
      }
    `}
`;

export const LinkContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 8px;
  min-width: 142px;
  height: 112px;
  overflow: hidden;
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  width: 48px;
  border-radius: 50%;
  margin: 0 0 13px;
  background-color: ${buildColor("white", "100")};
  border: 1px solid ${buildColor("grey", "L2")};

  :hover {
    background-color: ${buildColor("navy", "100")};
  }
`;

export const UpcomingRacesWrapper = styled.section`
  width: 100%;
  ${({ showHeader }) =>
    showHeader &&
    css`
      background-color: ${buildColor("white", "100")};
      border-top: 1px solid ${buildColor("grey", "L2")};
      border-bottom: 1px solid ${buildColor("grey", "L2")};
    `}
`;

export const EmptyState = styled.div`
  border-radius: 2px;
`;

export const EmptyBackground = styled.div`
  background-color: ${buildColor("white", "100")};
  padding: 8px;
`;

export const MessageWrapper = styled.div`
  padding: 0 12px 12px;
`;

export const NoRacesContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0 16px 12px;
  justify-content: space-between;
`;

export const NoRacesMessage = styled.span`
  display: flex;
  align-items: center;
  font-family: ${fontNormal};
  font-size: ${defaultSize};
  line-height: 125%;
  color: ${buildColor("grey", "D3")};
`;
